import {
  Breakpoints,
  BreakpointWrapper,
  styled,
  Text,
  TextAlignment,
  TextAppearance,
  TextColor,
} from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { TriggerProps } from 'src';
import { LanzamientoTaigoForm } from 'src/forms';

import { FourthSlideDesktop, FourthSlideMobile } from '.';

export interface SlideProps {
  blueSelected: boolean;
  redSelected: boolean;
  setBlueSelected: React.Dispatch<React.SetStateAction<boolean>>;
  setRedSelected: React.Dispatch<React.SetStateAction<boolean>>;
  slideConfig: SlideConfig;
  setSelectedJourney: (selectedJourney: JSX.Element, skipTrackButtonClick?: boolean) => void;
  fullPageApi: any;
}

interface SlideConfig {
  firstDivision: Copies;
  secondDivision: Copies;
}
interface Copies {
  title: string;
  subtitle: JSX.Element;
  options: string[];
  preButton: string;
}

const slidesConfig: SlideConfig = {
  firstDivision: {
    title: 'Deportivo',
    subtitle: (
      <>
        ¡La aventura te llama!
        <br />
        <Text bold>Elige tu excusa para vivirlo todo</Text>
      </>
    ),
    options: [
      'Voy a prepararme para los San Fermines en Pamplona.',
      'Ese día subo a los Picos de Europa con la unión excursionista.',
      'Participo en una competición de surf en el Cantábrico.',
    ],
    preButton: 'Y gana una visita a Volkswagen Navarra y un plan aventurero en Alma Hotels.',
  },
  secondDivision: {
    title: 'Urbanita',
    subtitle: (
      <>
        ¡La ciudad es tuya!
        <br />
        <Text bold>Elige tu excusa para vivirlo todo</Text>
      </>
    ),
    options: [
      'He quedado con los amigos para irme de pintxos por Pamplona.',
      'Me han invitado al estreno de una peli en un autocine.',
      'Asisto a una conferencia en Navarra sobre innovación digital.',
    ],
    preButton: 'Y gana una visita a Volkswagen Navarra y una experiencia exclusiva en Alma Hotels.',
  },
};

export function FourthSlide({ setSelectedJourney, fullPageApi }: any) {
  const [blueSelected, setBlueSelected] = useState(false);
  const [redSelected, setRedSelected] = useState(false);

  return (
    <div>
      <BreakpointWrapper max={Breakpoints.b960}>
        <FourthSlideMobile
          blueSelected={blueSelected}
          setBlueSelected={setBlueSelected}
          redSelected={redSelected}
          setRedSelected={setRedSelected}
          slideConfig={slidesConfig}
          setSelectedJourney={setSelectedJourney}
          fullPageApi={fullPageApi}
        />
      </BreakpointWrapper>

      <BreakpointWrapper min={Breakpoints.b960}>
        <FourthSlideDesktop
          blueSelected={blueSelected}
          setBlueSelected={setBlueSelected}
          redSelected={redSelected}
          setRedSelected={setRedSelected}
          slideConfig={slidesConfig}
          setSelectedJourney={setSelectedJourney}
          fullPageApi={fullPageApi}
        />
      </BreakpointWrapper>
    </div>
  );
}

export const CTATaigo = styled.button<{ expanded?: boolean; otherIsSelected?: boolean, solid?: boolean }>`
  background-color: ${(props)=> props.solid ? '#ffffff' : 'transparent'};
  border: 2px solid #ffffff;
  color: ${(props)=> props.solid ? '#001E50' : '#ffffff'};
  border-radius: 500px;
  padding: ${(props) => (props.otherIsSelected ? '6px 12px' : props.expanded ? '8px 112px' : '8px 20px')};
  max-width: 318px;
  width: 100%;
  cursor: pointer;

  font-family: var(--font-family-text, vw-text, Helvetica, Arial, sans-serif);
  font-size: ${(props) => (props.otherIsSelected ? '12px' : '16px')};
  font-weight: ${(props)=> props.solid ? '700' : '400'};
  line-height: 20px;

  &:hover {
    opacity: 0.8;
  }

  @media screen and (min-width: 1280px) {
    font-size: 20px;
    padding: ${(props) => props.expanded ? '12px 112px' : '12px 20px'};
  }
  @media screen and (min-width: 1600px) {
    font-size: 24px;
    padding: ${(props) => (props.expanded ? '12px 112px' : '12px 24px')};
  }
  @media screen and (min-width: 1920px) {
    font-size: 32px;
    padding: ${(props) => (props.expanded ? '20px 112px' : '20px 32px')};
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  color: #ffffff;

  @media screen and (min-width: 1280px) {
    gap: 32px;
  }
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  text-align: left;

  @media screen and (min-width: 960px) {
    padding: 16px 0;
    gap: 12px;
  }
  @media screen and (min-width: 1280px) {
    padding: 32px 0;
  }
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  & div {
    cursor: pointer;
  }
  @media screen and (min-width: 960px) {
    gap: 20px;
  }
`;

export const RadioInput = styled.input`
  display: none;
  vertical-align: middle;
  cursor: pointer;

  & label:before {
    border: 2px solid orange;
  }
`;

export const Radio = styled.div<{ checked: boolean }>`
  width: 12px;
  height: 12px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid #ffffff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;

  @media screen and (min-width: 560px) {
    margin-bottom: 0;
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: 1280px) {
    width: 20px;
    height: 20px;
  }
  /* margin-right: 7px; */

  cursor: pointer;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: block;
    background: ${(props) => (props.checked ? '#FFFFFF' : 'transparent')};
  }
`;

interface OptionsProps {
  subtitle: JSX.Element;
  options: string[];
  ctaCopy: string;
  preButton: string;
  setSelectedJourney: (selectedJourney: JSX.Element, skipTrackButtonClick?: boolean) => void;
  fullPageApi: any;
  estilo: string;
}

// a partir de 960px
export const OptionsDesktop = ({ subtitle, options, setSelectedJourney, ctaCopy, preButton, estilo }: OptionsProps) => {
  const [checkedOption, setCheckedOption] = useState(null);
  const [ errorExcusa, setErrorExcusa ] = useState(null);

  const fields = {
    excusa: checkedOption,
    estiloExcusa: estilo,
  };

  return (
    <OptionsContainer>
      <BreakpointWrapper max={Breakpoints.b1280}>
        <Text appearance={TextAppearance.copy250} color={TextColor.inherit} textAlign={TextAlignment.center}>
          {subtitle}
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280}>
        <Text appearance={TextAppearance.copy300} color={TextColor.inherit} textAlign={TextAlignment.center}>
          {subtitle}
        </Text>
      </BreakpointWrapper>

      <OptionsWrapper>
        {options.map((option) => (
          <Option
            onClick={() => {
              setCheckedOption(option);
            }}
          >
            <RadioInput
              onClick={() => {
                setCheckedOption(option);
              }}
            />
            <Radio
              onClick={() => {
                setCheckedOption(option);
              }}
              checked={checkedOption === option}
            />
            <BreakpointWrapper max={Breakpoints.b1280}>
              <Text appearance={TextAppearance.copy200} color={TextColor.inherit} textAlign={TextAlignment.center}>
                {option}
              </Text>
            </BreakpointWrapper>
            <BreakpointWrapper min={Breakpoints.b1280}>
              <Text appearance={TextAppearance.copy250} color={TextColor.inherit} textAlign={TextAlignment.center}>
                {option}
              </Text>
            </BreakpointWrapper>
          </Option>
        ))}
      </OptionsWrapper>
      <BreakpointWrapper max={Breakpoints.b1280}>
        <Text appearance={TextAppearance.copy250} color={TextColor.inherit} textAlign={TextAlignment.center}>
          {preButton}
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280}>
        <Text appearance={TextAppearance.copy300} color={TextColor.inherit} textAlign={TextAlignment.center}>
          {preButton}
        </Text>
      </BreakpointWrapper>
      <div>
        {
          errorExcusa ? (
            <div style={{paddingBottom: '8px'}}>
              <Text appearance={TextAppearance.copy150} color={TextColor.inherit} textAlign={TextAlignment.center}>
                Elige una excusa para poder continuar
              </Text>
            </div>
          ) : null
        }
        <CTATaigo
          onClick={() => {
            if(checkedOption) {
              setSelectedJourney(<LanzamientoTaigoForm updatedFormData={{ fields }}/>);
              setErrorExcusa(false);
            }  else {
              setErrorExcusa(true);
            }
          }}
          expanded={false}
          solid
        >
          {ctaCopy}
        </CTATaigo>
      </div>
    </OptionsContainer>
  );
};
//hasta 959px
export const OptionsMobile = ({ subtitle, options, setSelectedJourney, ctaCopy, preButton, estilo }: OptionsProps) => {
  const [checkedOption, setCheckedOption] = useState(null);
  const [ errorExcusa, setErrorExcusa ] = useState(null);

  const fields = {
    excusa: checkedOption,
    estiloExcusa: estilo,
  };

  return (
    <OptionsContainer>
      <Text appearance={TextAppearance.copy200} color={TextColor.inherit} textAlign={TextAlignment.center}>
        {subtitle}
      </Text>
      <OptionsWrapper>
        {options.map((option) => (
          <Option
            onClick={() => {
              setCheckedOption(option);
            }}
          >
            <RadioInput />
            <Radio
              onClick={() => {
                setCheckedOption(option);
              }}
              checked={checkedOption === option}
            />
            <Text appearance={TextAppearance.copy150} color={TextColor.inherit}>
              {option}
            </Text>
          </Option>
        ))}
      </OptionsWrapper>
      <Text appearance={TextAppearance.copy200} color={TextColor.inherit} textAlign={TextAlignment.center} bold>
        {preButton}
      </Text>
      <div>
        {
            errorExcusa ? (
              <div style={{paddingBottom: '4px'}}>
                <Text appearance={TextAppearance.copy100} color={TextColor.inherit} textAlign={TextAlignment.center}>
                  Elige una excusa para poder continuar
                </Text>
              </div>
            ) : null
          }
        <CTATaigo
          onClick={() => {
            if(checkedOption) {
              setSelectedJourney(<LanzamientoTaigoForm updatedFormData={{ fields }}/>);
              setErrorExcusa(false);
            }  else {
              setErrorExcusa(true);
            }       
          }}
          solid
          expanded={false}
        >
          {ctaCopy}
        </CTATaigo>
      </div>
    </OptionsContainer>
  );
};
